<template>
  <div id="form-container" ref="formContainer">
    <b-container fluid>
      <h1>
        Correct Date of Birth
      </h1>
      <div>
        Any DOB change may take up to one month to be processed by MDH.
      </div>
      <b-form class="mt-3">
        <b-row>
          <b-col cols="4">
            <BaseDateOfBirthInput v-model="profile.dateOfBirth"
                                 :v="$v.profile.dateOfBirth"
                                 slug="dob"
                                 label="Date of Birth"
                                 setId="dob"/>

          </b-col>
        </b-row>
        <b-row>
          <b-col>
            You must upload a copy of your Driver's License, ID Card, Passport, or Birth Certificate.
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            Current attached file: <span>{{!attachment ? 'No file attached' : attachment.filename}}</span>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <FileAttachment v-on:attachment-added="addAttachment"
                            :attachment-type-options="opts.attachmentOptions"
                            describedBy="attachment"
                            id="attachment"
            />
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="2">
            <b-button type="button" variant="primary" @click="showConfirmModal">Update</b-button>
          </b-col>
        </b-row>
      </b-form>
      <b-modal id="confirm-modal" hide-header hide-footer>
        <h2>Confirm Date of Birth Change</h2>
        <hr/>
        <form ref="form" @submit.prevent="updateDob">
          You are requesting to change your date of birth to {{formatDate(profile.dateOfBirth)}}.
          <p class="mt-2">Press Confirm to submit this date of birth change request or Cancel to return to the request view.</p>
          <div>
            <b-button @click="closeConfirmModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
            <b-button type="submit" variant="primary" :disabled="disableButton">Confirm</b-button>
          </div>
        </form>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import axios from "axios"
import axiosRetry from 'axios-retry'
import { required, maxLength, minLength } from 'vuelidate/lib/validators'
import { toastService } from "@/mixins/toastService"
import FileAttachment from "@/components/templates/input/FileAttachment";
import BaseDateOfBirthInput from "../../components/templates/input/BaseDateOfBirthInput.vue";
import moment from "moment/moment";

axiosRetry(axios, { retries: 0,
  retryDelay: axiosRetry.exponentialDelay  })

export default {
  data: () => ({
    disableButton: false,
    profile: {},
    opts: {
      attachmentOptions: []
    },
    attachment: null
  }),
  components:{
    BaseDateOfBirthInput,
    FileAttachment
  },
  validations() {
    return {
      profile: {
        dateOfBirth: {
          required
        },
        attachment: { required },
      }
    }
  },
  methods: {
    initialize() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/profile/user`)
          .then(response => {
            this.profile = response.data
          })
    },
    loadAttachmentOptions(){
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/attachments/public/dobTypes`, {ignoreHeader: true})
          .then(response => {
            for(let type of response.data){
              this.opts.attachmentOptions.push({
                value: type.code,
                text: type.description
              })
            }
          })
    },
    addAttachment(value){
      this.profile.attachment = value
      this.attachment = value
      setTimeout( () => this.$emit('attachment-complete'), 10000);
    },
    updateDob() {
      this.disableButton=true;
      this.$v.$touch()
      if (!this.$v.$invalid) {
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/change/dob/`, this.profile)
            .then(response => {
              toastService.showRootToast("DOB Update", "Your Date of Birth change has been submitted.", "success", this.$root)
            }) .catch(error => {
              toastService.showRootToast("Error", "An error has occurred " , "danger", this.$root)
            this.disableButton = false;
            }).finally(()=>{
              this.closeConfirmModal();

        })
      }
      else{
        this.disableButton=false;
      }
    },
    showConfirmModal(){
      this.$bvModal.show('confirm-modal');
    },
    closeConfirmModal(){
      this.$bvModal.hide('confirm-modal');
    },
    formatDate(unformattedDate){
      let formattedDate = moment(unformattedDate);
      if(!formattedDate.isValid()) return 'N/A';
      return formattedDate.format("MM/DD/YYYY");
    },
  },
  created() {
    this.initialize()
    this.loadAttachmentOptions()
    document.title = "Correct Date of Birth  - NAR"
  },
  mixins: [
    toastService
  ],
}
</script>